import { combineReducers } from "redux";
import chatReducer from "./chat/reducer";
import type { IAppChatState } from "./chat/reducer";
import kemReducer from "./kem/reducer";
import type { IKemState } from "./kem/reducer";
import userReducer from "./user/reducer";
import type { IAppUserState } from "./user/reducer";

const rootReducer = combineReducers({
  user: userReducer,
  kem: kemReducer,
  chat: chatReducer,
});

export interface AppState {
  user: IAppUserState;
  kem: IKemState;
  chat: IAppChatState;
}

export default rootReducer;
